import React, { useEffect, useState, memo } from "react";
import Router from "next/router";
import PubSub from 'pubsub-js'
import swal from '@sweetalert/with-react';

import Service from "../services/service";
import { connect } from 'react-redux';
import actions from '../redux/actions';
import ResponsiveModal from './responsiveModal.js'

import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

/* esse cara aqui faz a avaliacao na plataforma */
const Index = (props) => {

  const [sending, setSending] = useState(false);
  const [criterios, setCriterios] = useState([]);
  const [open, setOpen] = useState(false);
  const [myModel, setModel] = useState(null);
  const [form, setForm] = useState({
      mensagem:"",
      id: "",
      avaliacao: {}
  });

  var subscribeModal = null;
  useEffect(() => {

    subscribeModal = PubSub.subscribe('openModalAvaliacaoColaborador', (type, model) => {
      if(model){
          openModal(model);
          setModel(model);
      }
    });

    return () => {
      PubSub.unsubscribe(subscribeModal);
    }
  }, []);

  /**************************************************/
  /* aqui eh quando abre o formulario de avaliacao */
  /**************************************************/
  const openModal = async (item) => {

    /* pega os criterios de avaliacao que o usuario logado quer avaliar */
    let resp = await Service.getCriterios('COLABORADOR');
    setCriterios(resp);

    setOpen(true);
    setForm({
      ...form,
      colaboradorId: item._id,
      mensagem: '',
      avaliacao: {}
    })
  }

  /**************************************************/
  /* muda os criterios de avaliacao */
  /**************************************************/
  const onChangeCriterio = (idCriterio, valor) => {
    var newCriterio = criterios.map(item => {
     if(item._id === idCriterio){
      item.value = valor
     }
     return item; 
    });

    setCriterios(newCriterio);
  }

  /**************************************************/
  /* muda os dados do form de avaliacao */
  /**************************************************/
  const handleChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setForm({
        ...form,
        [name]: value
    });
  }

  /**************************************************/
  /* aqui eh quando envia o formulario de avaliacao */
  /**************************************************/
  const handleSubmit = async (event) => {

    event.preventDefault();

    const id = myModel._id; // id da diarista
    const isAuthenticated = props.isAuthenticated;

    if(!isAuthenticated){
      PubSub.publish('openModal', myModel);
      return false;
    }

    if(props.user.type !== 'CONTRATANTE'){
      swal('', 'A avaliação está disponível apenas para contratantes', 'error');
      handleClose();
      return false;
    }

    let resp = null;

    if(form.mensagem.trim() === ''){
      swal('', 'Por favor, comente corretamente a avaliação!', 'error');
      return false;
    }

    let criteriosObrigatorios = criterios.every(item => item.value);
    if(!criteriosObrigatorios){
      swal('', 'Selecione as estrelas em todos os critérios', 'error');
      return false;
    }

    criterios.forEach(item => {
      form.avaliacao[item._id] = item.value;
    });

    setSending(true);
    PubSub.publish('backdrop', true);

    resp = await Service.post(`${Service.api}/solicitacoes/matchAvaliation`, form);

    if(!resp){
      swal('', 'Ocorreu algum erro,tente novamente', 'error');
      setSending(false);
      return false
    }

    swal({content: <div>
        <p className="text-center">{props?.user?.nome}, sua avaliação e seu comentário foram cadastrados com sucesso.</p>
        <h3 className="barlow fw-bold">Sua avaliação é importante para plataforma!</h3>
      </div>, icon: 'success'}).then(() => {

      if(myModel.callback){
        myModel.callback()
      }

      handleClose();

    }).finally(() => {
      setSending(false);
      PubSub.publish('backdrop', false);
    });
  }

  /* fecha e destroy o modal */
  const handleClose = () => {

    setOpen(false);
    setForm({
        id: '',
        mensagem: '',
        avaliacao: {}        
    });
  }

  const rating = new Array(5).fill();

  return (
    <ResponsiveModal onClose={handleClose} open={open}>
      <form onSubmit={handleSubmit} disabled={sending} className="d-flex flex-column h-100 overflow-hidden">
        <DialogContent dividers={true}>
            <fieldset className="">
            {
              criterios.map((item, index) => {
                return (
                  <div key={item._id} className="mb-3">

                    <div className="d-flex justify-content-between align-items-center gap-3 mb-1">
                        <p className="lh fw-bold barlow text-uppercase m-0 flex-fill">{item.nome}</p>
                        <div className="star-rating">
                        {
                          rating.map((i, x) =>
                            <React.Fragment key={`simple-controlled-${item._id}-${x}`}>
                              <input type="radio" name={`simple-controlled-${item._id}`} id={`simple-controlled-${item._id}-${x}`} checked={item?.value === (rating.length-x)} value={rating.length-x} onChange={() => {onChangeCriterio(item._id, rating.length-x)}} />
                              <label  htmlFor={`simple-controlled-${item._id}-${x}`}></label>
                            </React.Fragment>
                        )}
                        </div>
                        
                    </div>
                    <small className="m-0 d-block lh-1 text-muted">{item.descricao}</small>

                  </div>
                )
              })
            }
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="mensagem">Comente sobre o serviço realizado:</label>
              <textarea name="mensagem" required={true} id="mensagem" className="form-control" rows="3" value={form.mensagem} onChange={handleChange} />
            </div>
            </fieldset>
        </DialogContent>
        <DialogActions>
          <button type="button" onClick={handleClose} className="w-100 btn btn-outline-secondary btn-lg btn-block text-uppercase">cancelar</button>
          <button type="submit" className="btn w-100 btn-block btn-lg btn-primary text-uppercase">{sending ? 'enviando...' : 'Enviar'}</button>
        </DialogActions>
      </form>
    </ResponsiveModal>
  )

}

const mapStateToProps = (state) => ({
    isAuthenticated: !!state.authentication.token,
    token: state.authentication.token,
    user: state.authentication.user
  }
);

export default memo(connect(mapStateToProps, actions)(Index));